@if (pluginTextEntityRepository.text$ | async; as text) {
  <span>
    {{ text }}
  </span>
}
